import { useState } from "react";
import { string } from "prop-types";
import Popup from "../../../../Common/js/components/Popup/Popup.jsx";

const propTypes = {
  content: string.isRequired,
};

const Tooltip = (props) => {
  const { content } = props;

  const [popUpHidden, setPopUpHidden] = useState(true);

  return (
    <span
      className="tooltip"
      onMouseEnter={() => setPopUpHidden(false)}
      onMouseLeave={() => setPopUpHidden(true)}
    >
      <svg className="tooltip__icon">
        <use
          xlinkHref={"/Areas/EGH/assets/img/svg-sprite.svg#info-circle-fill"}
        ></use>
      </svg>
      <Popup
        isHidden={popUpHidden}
        left={8}
        top={8}
        offset={12}
        triangleAlignment={0.1}
        triangleSide="bottom"
        flipToContain="viewport"
        nudgeToContain="viewport"
        width={360}
        isTooltip
        className="tooltip__popup"
      >
        <span dangerouslySetInnerHTML={{ __html: content }} />
      </Popup>
    </span>
  );
};

Tooltip.propTypes = propTypes;
export default Tooltip;
